import { render } from "./Code.vue?vue&type=template&id=650e006b&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"

import "./Code.vue?vue&type=style&index=0&id=650e006b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-650e006b"

export default script